'use client'

import { Icon } from '@/components/ui/icon'
import { MediaItem } from '@/lib/types/media'
// HeroUI v3 removed Image component
import { useState } from 'react'
import { Lightbox } from '../../ui/lightbox'

interface ServiceMediaGalleryProps {
  media?: MediaItem[]
}

export function ServiceMediaGallery({ media = [] }: ServiceMediaGalleryProps) {
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [isLightboxOpen, setIsLightboxOpen] = useState(false)

  const hasMedia = media && media.length > 0

  return (
    <div className='space-y-4'>
      {/* Main Image or Placeholder */}
      <div
        className='overflow-hidden relative cursor-pointer aspect-[4/3] rounded-medium'
        onClick={() => hasMedia && setIsLightboxOpen(true)}
      >
        {hasMedia ? (
          <img
            src={media[selectedIndex].url}
            alt={media[selectedIndex].altText || 'Service image'}
            className='object-cover w-full h-full transition-transform hover:scale-105'
          />
        ) : (
          // Task 15F: was hardcoded hex ('#f0f1f5'/'#e2e8f0'). The app's own
          // light-gray surface tier tokens (--surface-secondary/--surface-
          // tertiary) carry the same "one step down from white" neutral
          // gradient role. text-muted on the darker stop: 5.49:1 (verified).
          <div className='flex justify-center items-center w-full h-full bg-gradient-to-br from-surface-secondary to-surface-tertiary'>
            <Icon icon='gallery-wide-bold' className='text-7xl sm:text-8xl text-muted' />
          </div>
        )}
      </div>

      {/* Thumbnail Grid — capped at 4; extra media is reachable via the lightbox, not a 5th+ thumbnail */}
      {hasMedia && media.length > 1 && (
        <div className='grid grid-cols-4 gap-2'>
          {media.slice(0, 4).map((item, index) => (
            <button
              key={index}
              onClick={() => setSelectedIndex(index)}
              className='overflow-hidden relative aspect-square rounded-medium'
            >
              <img
                src={item.url}
                alt={item.altText || `Thumbnail ${index + 1}`}
                className={`object-cover w-full h-full transition-transform hover:scale-110 ${
                  selectedIndex === index ? 'ring-2 ring-primary' : ''
                }`}
              />
            </button>
          ))}
        </div>
      )}

      {/* Lightbox - only render if we have media */}
      {hasMedia && (
        <Lightbox
          isOpen={isLightboxOpen}
          onClose={() => setIsLightboxOpen(false)}
          media={media}
          currentIndex={selectedIndex}
          onIndexChange={setSelectedIndex}
        />
      )}
    </div>
  )
}
